import React, { useEffect, useState } from 'react';
import DashSession from './DashSessions';
import Sidebar from './Sidebar';
import logo from '../../images/logo/header-logo.jpg';
import Footer from '../components/Footer';
import { User, LogOut, Key, ChevronDown } from 'lucide-react';
import About from './About';
import ResetPasswordModal from './ResetPasswordModal';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetData } from '../../redux/reducers/leadReducers';
import DownloadSessionPDFButton from '../../components/Session/SessionPdfDownload';
import SessionBrousher from '../components/SessionBrousher';

function LeadDashboard() {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const leadData = useSelector((state) => state.leads.leadData);

// console.log(">>>",leadData)
  useEffect(() => {
    if (leadData) {
      setUser(leadData?.user);
    }
  }, [leadData]);

     const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  const handleLogout = () => {
    dispatch(resetData()); 
    navigate('/'); 
    setIsProfileOpen(false);
  };

  const handleResetPassword = () => {
    setIsResetModalOpen(true);
    setIsProfileOpen(false);
  };

  return (
  
     <div className="min-h-screen bg-gray-50">
      {/* <header className="bg-white p-4 shadow-md relative">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
             <a href="/" className="flex-shrink-0">
            <img 
              src={logo}
              alt="IFFK 2025" 
              className="h-12 w-auto" 
            />
            </a>
          </div>

          <div className="relative">
            <button
              onClick={toggleProfile}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Profile menu"
            >
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-white" />
              </div>
              
              <span className="hidden sm:block text-gray-700 font-medium">
                {user?.full_name}
              </span>
              
              <ChevronDown 
                className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
                  isProfileOpen ? 'rotate-180' : ''
                }`} 
              />
            </button>

            {isProfileOpen && (
              <>
                <div 
                  className="fixed inset-0 z-10 md:hidden" 
                  onClick={() => setIsProfileOpen(false)}
                />
                
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-20 animate-in slide-in-from-top-2 duration-200">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                        <User className="w-6 h-6 text-white" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {user?.full_name}
                        </p>
                        <p className="text-xs text-gray-500 truncate">
                          {user?.email}
                        </p>
                      </div>
                    </div>
                  </div>

                 
                  <div className="py-2">
                    <button
                      onClick={handleResetPassword}
                      className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                    >
                      <Key className="w-4 h-4 mr-3 text-gray-400" />
                      Reset Password
                    </button>
                    
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                    >
                      <LogOut className="w-4 h-4 mr-3 text-red-500" />
                      Logout
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </header> */}

      <header className="bg-white p-4 shadow-md relative">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex-shrink-0">
              <img 
                src={logo}
                alt="IFFK 2025" 
                className="h-12 w-auto" 
              />
            </a>
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-4">
            {/* Download Button - Only show on md and up */}
             <div className="hidden md:block">
              <SessionBrousher />
            </div>
            <div className="hidden md:block">
              <DownloadSessionPDFButton label="Session Export"/>
            </div>

            {/* Profile Button + Dropdown */}
            <div className="relative">
              <button
                onClick={toggleProfile}
                className="flex items-center p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                aria-label="Profile menu"
              >
                {/* Avatar */}
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                  <User className="w-5 h-5 text-white" />
                </div>

                {/* Name and Chevron - Only on md and up */}
                <div className="hidden md:flex items-center space-x-2 ml-2">
                  <span className="text-gray-700 font-medium">{user?.full_name}</span>
                  <ChevronDown
                    className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
                      isProfileOpen ? 'rotate-180' : ''
                    }`}
                  />
                </div>
              </button>

              {/* Dropdown */}
              {isProfileOpen && (
                <>
                  {/* Overlay for mobile */}
                  <div
                    className="fixed inset-0 z-10 md:hidden"
                    onClick={() => setIsProfileOpen(false)}
                  />

                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-20 animate-in slide-in-from-top-2 duration-200">
                    {/* User Info */}
                    <div className="px-4 py-3 border-b border-gray-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                          <User className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-gray-900 truncate">
                            {user?.full_name}
                          </p>
                          <p className="text-xs text-gray-500 truncate">
                            {user?.email}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Mobile-only Download Button */}
                    <div className="md:hidden px-4 py-2 border-b border-gray-100">
                       <SessionBrousher />
                    </div>
                    <div className="md:hidden px-4 py-2 border-b border-gray-100">
                     <DownloadSessionPDFButton label="Session Export" />
                    </div>

                    {/* Actions */}
                    <div className="py-2">
                      <button
                        onClick={handleResetPassword}
                        className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                      >
                        <Key className="w-4 h-4 mr-3 text-gray-400" />
                        Reset Password
                      </button>

                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                      >
                        <LogOut className="w-4 h-4 mr-3 text-red-500" />
                        Logout
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </header>



      {/* <div className='card p-5'>
        <div className="flex flex-col lg:flex-row">
          <div className="flex-1 lg:w-2/3 gap-2">
            <About />
            <DashSession />
          </div>

          <div className="lg:w-1/4 p-4">
            <Sidebar />
          </div>
        </div>
      </div>
      <Footer />
    </div> */}
    <div className="p-5">
  <div className="bg-gray-100 rounded-lg shadow-md p-4">
    <div className="flex flex-col lg:flex-row gap-6">
      
      {/* Main Content */}
      <div className="flex-1 lg:w-2/3 flex flex-col gap-4">
        <About />
        <DashSession />
      </div>

      {/* Sidebar */}
      <div className="lg:w-1/5">
        <Sidebar />
      </div>
    </div>
  </div>

  
</div>
<Footer />
 <ResetPasswordModal 
        isOpen={isResetModalOpen} 
        onClose={() => setIsResetModalOpen(false)} 
      />
</div>
  );
}

export default LeadDashboard;
